export default __webpack_public_path__ + "static/media/imagem_doone.f7316400.png";